module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAMAAAAPkIrYAAAAKlBMVEUAAADIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMi17ZRRAAAADXRSTlMAJbsZvL3X2Boz/jIxclsGzgAAANpJREFUWMPt1kkOwyAMBVBSaOLScv/rljaKMoLH7PzX9lsgWzgEj8fj8dyc4RHRmpgGkvUsI4bFqSSSVQsRDK8glzIorJhF9cuZVK+BTbVbBFSrSUTVtvHcJqSuMDF1xhTUEVNRe0xJbTE1tWIG1IKBBTVjLxvqj2UjKoR3LvljQ9Vnz2WKRtTvvSyweRjAAlvmKuqxdUTV2Hbaldh+cVTYcQcV2HmdxdjVOgsxaP1DfAza/yMXg96/zcOgf09wMMDuHDoG+P1FxYByFxKxZHivWt7RHo/H41HkCyleCW1TvtdeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close_black.png
// module id = 0yhD
// module chunks = 1